export function setToken(token) {
    return localStorage.setItem('token', token)
}

export function getToken() {
    return localStorage.getItem('token')
}

export function setUserInfo(data) {
    return localStorage.setItem('userInfo', JSON.stringify(data))
}

export function getUserInfo() {
    return JSON.parse(localStorage.getItem('userInfo')) || null
}
